export function shopSearchForPublishers(publisher: string | string[] | null) {
  return { 
    publisher: publisher 
      ? (Array.isArray(publisher) ? publisher : [publisher])
        .map(formatToUrlEncoded)
        .sort() 
      : undefined, 
    page: 1 
  };
}


function formatToUrlEncoded(publisher: string) {
  return publisher.toLowerCase().trim().replace(/\s+/g, '-');
}